import React from 'react';
import { styled, Card } from '@teko/ui';
import { ProductCard } from '../ProductCard/ProductCard.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledProductsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const StyledProductCard = styled(ProductCard)`
  box-sizing: border-box;
  width: ${(props) => 100 / props.productsPerRow}%;
  border-radius: 0.5rem;
`;
const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 16px;
  margin-bottom: 16px;
  background-color: #e0e0e0;
`;
const ProductsGrid = ({
  products = [],
  productsPerRow = 5,
  regionName
}) => {
  return /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(StyledProductsGrid, null, products.map((product, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, /* @__PURE__ */ React.createElement(StyledProductCard, __spreadProps(__spreadValues({
    productsPerRow,
    key: product.sku
  }, product), {
    regionName
  })), index % productsPerRow === productsPerRow - 1 && index !== products.length - 1 && /* @__PURE__ */ React.createElement(Line, null)))));
};

export { ProductsGrid };
